(function () {
  // -----------------------------
  // 共通ユーティリティ
  // -----------------------------
  function getVariant() {
    try {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      return params.get('variant');
    } catch (e) {
      return null;
    }
  }

  // Shopify グローバルから customerId を取る
  function getGlobalCustomerId() {
    try {
      const fromAnalytics = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId;
      const fromSt = window.__st && window.__st.cid;

      if (fromAnalytics) return String(fromAnalytics);
      if (fromSt) return String(fromSt);

      return '';
    } catch (e) {
      return '';
    }
  }

  // ログインしているかどうか
  function isLoggedIn() {
    return !!getGlobalCustomerId();
  }

  // -----------------------------
  // API 呼び出し系
  // -----------------------------
  async function submitFavorite(handle, variant, customerIdParam) {
    const cid = customerIdParam || getGlobalCustomerId(); // DOM から来た ID がなければグローバルから補完

    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        handle: handle,
        variant: variant,
        customerId: cid,
      }),
    };

    await fetch('/tools/prime-review/api/addFavorite', fetchOptions);

    if (!cid) {
      // ゲスト（customerId が無い）→ localStorage 管理
      addCookieFavorite(variant);
    } else {
      // ログインユーザー → フローティングカウントを更新
      changeFloatCount(1);
    }
  }

  async function removeFavorite(handle, variant, customerIdParam) {
    const cid = customerIdParam || getGlobalCustomerId();

    if (!cid) {
      removeCookieFavorite(variant);
      return true;
    }

    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        handle: handle,
        variant: variant,
        customerId: cid,
      }),
    };

    await fetch('/tools/prime-review/api/removeFavorite', fetchOptions);
    changeFloatCount(-1);
  }

  // グローバルに公開（必要なら）
  window.PrimeReviewFavorite = {
    submitFavorite: submitFavorite,
    removeFavorite: removeFavorite,
  };

  // -----------------------------
  // 通常のお気に入りボタン（.mxpr-favorites-button）
  // -----------------------------
  async function initFavorite(event) {
    event.preventDefault();
    // カートボタンなどにクリックが伝播しないように
    event.stopPropagation();

    const target = event.currentTarget || event.target.closest('.mxpr-favorites-button');
    if (!target) return;

    const allowGuest = target.dataset.allowGuest === 'true';
    const customerIdFromDom = target.dataset.customerId || '';

    // ログイン必須（ゲスト不可）の場合
    if (!allowGuest) {
      if (!isLoggedIn()) {
        // アラートを出してからログイン画面へ
        alert(target.dataset.alert);

        // ★ 今いる商品ページの URL をそのまま戻り先にする
        const returnUrl = window.location.pathname + window.location.search;
        location.href = '/account/login?return_url=' + encodeURIComponent(returnUrl);
        return;
      }
    }

    const variant = getVariant() || target.dataset.defaultVariantId;
    const isActive = target.dataset.active === 'true';
    const handle = target.dataset.handle; // ★ 追加：対象商品のハンドル取得

    // メッセージ要素取得
    const existsMessage = document.getElementById('mxpr-already-exists');
    const completeMessage = document.getElementById('mxpr-complete-message');

    if (isActive) {
      // ▼ すでにお気に入り → 解除
      await removeFavorite(handle, variant, customerIdFromDom);

      // クリックされたボタン
      target.classList.remove('mxpr-favorites-button--active');
      target.dataset.active = 'false';

      // ★ 同じ商品の他のボタンもすべて OFF
      document.querySelectorAll('.mxpr-favorites-button[data-handle="' + handle + '"]').forEach(function (btn) {
        if (btn === target) return;
        btn.classList.remove('mxpr-favorites-button--active');
        btn.dataset.active = 'false';
      });

      if (completeMessage) completeMessage.style.display = 'none';
      if (existsMessage) existsMessage.style.display = 'none';
    } else {
      // ▼ まだお気に入りではない → 追加
      await submitFavorite(handle, variant, customerIdFromDom);

      // クリックされたボタン
      target.classList.add('mxpr-favorites-button--active');
      target.dataset.active = 'true';

      // ★ 同じ商品の他のボタンもすべて ON
      document.querySelectorAll('.mxpr-favorites-button[data-handle="' + handle + '"]').forEach(function (btn) {
        if (btn === target) return;
        btn.classList.add('mxpr-favorites-button--active');
        btn.dataset.active = 'true';
      });

      if (existsMessage) existsMessage.style.display = 'none';
      if (completeMessage) completeMessage.style.display = 'inline';
    }
  }

  // -----------------------------
  // ハート型「いいね」ボタン（.mxpr-like-heart）
  // -----------------------------
  async function initLike(event) {
    event.preventDefault();
    event.stopPropagation();

    const target = event.currentTarget || document.querySelector('.mxpr-like-heart');
    if (!target) return;

    const allowGuest = target.dataset.allowGuest === 'true';
    const customerIdFromDom = target.dataset.customerId || '';

    if (!allowGuest) {
      if (!isLoggedIn()) {
        alert(target.dataset.alert);

        const returnUrl = window.location.pathname + window.location.search;
        location.href = '/account/login?return_url=' + encodeURIComponent(returnUrl);
        return;
      }
    }

    const heartIcon = document.getElementById('mxpr-like-heart-icon');
    const loadingIcon = document.getElementById('mxpr-like-loading-icon');
    if (heartIcon && loadingIcon) {
      heartIcon.style.display = 'none';
      loadingIcon.style.display = 'block';
    }

    const variant = getVariant() || target.dataset.defaultVariantId;

    let favoriteCount = Number(target.dataset.count || 0);

    if (target.dataset.active === 'true') {
      await removeFavorite(target.dataset.handle, variant, customerIdFromDom);
      favoriteCount = Math.max(0, favoriteCount - 1);
      target.classList.remove('mxpr-like-heart-active');
      target.dataset.active = 'false';
    } else {
      await submitFavorite(target.dataset.handle, variant, customerIdFromDom);
      favoriteCount = favoriteCount + 1;
      target.classList.add('mxpr-like-heart-active');
      target.dataset.active = 'true';
    }

    target.dataset.count = favoriteCount;
    const link = document.getElementById('mxpr-like-count-link');
    if (link) {
      link.innerText = favoriteCount;
    }

    if (heartIcon && loadingIcon) {
      heartIcon.style.display = 'block';
      loadingIcon.style.display = 'none';
    }
  }

  // -----------------------------
  // ゲスト用 localStorage 管理
  // -----------------------------
  function getVariantInfo(variantId) {
    const product = window.mxProductInfo;
    let variant;
    if (variantId) {
      variant = product.variants.find((v) => v.id == variantId);
    }
    if (!variant) {
      variant = product.variants[0];
    }

    const variantInfo = {
      imageUrl: product.featured_image || null,
      url: window.location.href,
      title: product.title,
      handle: product.handle,
      variantTitle: variant.public_title,
      variantId: variant.id,
      price: variant.price,
      tags: product.tags,
    };

    if (!variant) {
      const prices = product.variants.map((v) => v.price);
      variantInfo.minPrice = Math.min(...prices);
      variantInfo.maxPrice = Math.max(...prices);
    }

    return variantInfo;
  }

  function addCookieFavorite(variantId) {
    const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    if (!favorites.some((favorite) => favorite.variantId == variantId)) {
      const variantInfo = getVariantInfo(variantId);
      favorites.push(variantInfo);
      localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
    }
    updateFloatCount();
  }

  function removeCookieFavorite(variantId) {
    const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    const index = favorites.findIndex((favorite) => favorite.variantId == variantId);
    if (index >= 0) {
      favorites.splice(index, 1);
      localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
    }
    updateFloatCount();
  }

  function updateFloatCount() {
    const floatCountDiv = document.getElementById('prime-review-favorites-count');
    if (floatCountDiv) {
      const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
      let count = favorites.length;
      floatCountDiv.innerText = String(count);
      floatCountDiv.style.display = count <= 0 ? 'none' : 'block';
    }
  }

  function changeFloatCount(add) {
    const floatCountDiv = document.getElementById('prime-review-favorites-count');
    if (floatCountDiv) {
      let count = Number(floatCountDiv.innerText) || 0;
      count = count + add;
      floatCountDiv.innerText = String(count);
      floatCountDiv.style.display = count <= 0 ? 'none' : 'block';
    }
  }

  // -----------------------------
  // Cookie から状態復元
  // -----------------------------
  function checkCookies(button) {
    const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    const handle = button.dataset.handle;

    if (favorites.some((favorite) => favorite.handle == handle)) {
      if (button.classList.contains('mxpr-favorites-button')) {
        button.classList.add('mxpr-favorites-button--active');
      } else {
        button.classList.add('mxpr-like-heart-active');
      }
      button.dataset.active = 'true';
    }
  }

  // -----------------------------
  // イベント登録
  // -----------------------------
  const buttons = document.getElementsByClassName('mxpr-favorites-button');
  for (let i = 0; i < buttons.length; i++) {
    // ゲストのときだけ cookie チェック
    if (!buttons[i].dataset.customerId) {
      checkCookies(buttons[i]);
    }
    buttons[i].addEventListener('click', initFavorite);
  }

  const heartButton = document.querySelector('.mxpr-like-heart');
  if (heartButton) {
    if (!heartButton.dataset.customerId) {
      checkCookies(heartButton);
    }
    heartButton.addEventListener('click', initLike);
  }

  console.log('[INFO] Prime Review (Favorites) has been launched: login check = ShopifyAnalytics/__st based');
})();
